import { parse } from 'date-fns';

// date or HH:mm string to number of minutes from midnight
export const dateToMinutesFromMidnight = (dateOrString: Date | string) => {
  const date = typeof dateOrString === 'string' ? parse(dateOrString, 'HH:mm', new Date()) : dateOrString;
  return date.getHours() * 60 + date.getMinutes();
};
